var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vdp-legend",style:({
        'height': this.computedHeight + 'px', 
        'width': this.computedWidth + 'px',
        'top': this.computedTop + 'px',
        'left': this.computedLeft + 'px',
        'position': 'relative'
    })},[_c('div',{style:({
            'position': 'absolute'
        }),attrs:{"id":this.legendElemID}}),_c('div',[_c('Axis',{ref:"continuous-legend-axis",attrs:{"pWidth":30,"pHeight":this.lHeight - 30,"pMarginTop":30,"pMarginLeft":0,"pMarginRight":this.lWidth - 100,"pMarginBottom":5,"variable":this.variable,"side":"right","getScale":this.getScale,"getStack":this.getStack,"showLabel":false}})],1),(_vm.showColorScalePicker)?_c('ColorScalePicker',{attrs:{"onSelect":_vm.changeColorScale},on:{"close":function($event){_vm.showColorScalePicker = false}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }